import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CONFIG } from '../../config';


@Injectable()
export class UtilsService {
  private config = CONFIG;

  constructor(
  ) {
  }

  public isObjectOnList(obj: object, list: Array<any>, key?: string) {
    let found = false;
    key = key || 'id';

    for (const item of list) {
      if (item[key] === obj[key]) {
        found = true;
      }
    }

    return found;
  }

  public getUUID() {
    return new Date().getTime();
  }

  public generateParams(params: any): HttpParams {
    let httpParams: HttpParams = new HttpParams();

    for (const key in params) {
      if (params[key] instanceof Array) {
        // tslint:disable-next-line:forin
        for (const value in params[key]) {
          httpParams = httpParams.append(key, params[key][value]);
        }
      } else {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return httpParams;
  }

  public getAPIPath(): string {
    return this.config.apiUrl;
  }

}
